import {OlServiceModel} from "@/modules/ol/service/ol-service-model";
import {OlService} from "@/modules/ol/service/ol-service";
import {getService} from "@/http/services/http-services-layer-service";
import {updateInfoLegends} from "@/helpers/layer/info/layer-info-legend-helper";
import {
    getDomainListItemsByBookmarkPresentationID,
    loadLayerOverViewDomainList,
    showHideLayerOverViewDomainList
} from "@/helpers/layer/overview/layer-overview-domain-list-helper";
import {
    clearInfoCharacteristics,
    loadInfoCharacteristics
} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {viewFit} from "@/helpers/ol/ol-view";
import {isMobile} from "@/helpers/mobile-helper";
import {zoomToLayer} from "@/helpers/ol/ol-zoom-helper";
import {isCesiumEnabled, reloadCesium} from "@/modules/cesium/cesium";
import {addLayerActive, removeLayerActive, removeLayerActiveElement} from "@/helpers/ol/ol-layer-active-helper";
import {getBranchItemByBookmarkPresentationID} from "@/helpers/tree-helper";
import {getAllBySelector, getBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {setLayerByViewResolution} from "@/helpers/ol/view/ol-view-resolutation-helper";
import {blockUnBlockZoomElement} from "@/helpers/layer-menu-helper";
import {loadMutationSelectOptions} from "@/helpers/tools/tools-mutation-helper";
import {reloadGeometryLayers} from "@/helpers/tools/tools-helper";
import {callService, getWfsByColumn} from "@/helpers/ol/ol-http-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper.js";
import {updateBackgroundSlider, updateBackgroundSliderValue} from "@/modules/ol/ol-background-switcher.js";
import {reloadOlSliderOptions} from "@/helpers/ol/ol-slider-helper.js";
import {getTemporaryLayerByIndex} from "@/helpers/layer/temporary/temporary-layer-helper.js";

let bookmarkPresentations = []

let layerNamePrefix = 'layer-'

window.layersLoaded = []

export function getLayers(withPrefix = false) {
    if(withPrefix) {
        const layers = []
        window.map.getLayers().forEach(layer => {
            if (layer && layer.get('name').includes(layerNamePrefix)) {
                layers.push(layer)
            }
        });
        return layers
    }
    return window.map.getLayers()
}

export function refreshLayer(name, withPrefix = true) {
    const layer = getLayerByName(name, withPrefix)
    if(layer) {
        layer.getSource().refresh()
    }
}

export function refreshAllActiveLayers(withPrefix = true) {
    window.layersActive.map((layerActive) => {
        refreshLayer(layerActive, withPrefix)
    })
}

export function getLayerByName(name, withPrefix = true) {
    let layerFound = null

    if(withPrefix) {
        name = getLayerNamePrefix() + name
    }

    if(window.map && typeof window.map.getLayers !== "undefined") {
        window.map.getLayers().forEach(layer => {
            if (layer && layer.get('name') === name) {
                layerFound = layer
            }
        });
    }
    return layerFound
}

export function removeLayer(name, withPrefix = true) {

    if(withPrefix) {
        name = getLayerNamePrefix() + name
    }

    window.map.getLayers().forEach(layer => {

        if (layer && layer.get('name') === name) {
            window.map.removeLayer(layer);
        }
    });
}

export function clearLayer(name, withPrefix = true) {
    if(withPrefix) {
        name = getLayerNamePrefix() + name
    }

    window.map.getLayers().forEach(layer => {

        if (layer && layer.get('name') === name) {
            layer.getSource().clear();
        }
    });
}

export function removeLayersIncludes(name) {
    const layersToRemove = []
    window.map.getLayers().forEach(layer => {
        if (layer && String(layer.get('name')).includes(name)) {
            layersToRemove.push(layer)
        }
    });

    layersToRemove.map(layer => {
        window.map.removeLayer(layer);
    })
}

export function getLayersIncludes(name) {
    const layers = []

    window.map.getLayers().forEach(layer => {
        if (layer && String(layer.get('name')).includes(name)) {
            layers.push(layer)
        }
    });

    return layers
}

export function getLayersIncludesFeatures(name) {
    const layers = getLayersIncludes(name)

    const features = []
    layers.map(layer => {
        layer.getSource().getFeatures().map( feature => {
            features.push(feature)
        })
    })

    return features
}

export function visibleLayersIncludes(name, visible = false) {
    window.map.getLayers().forEach(layer => {
        if (layer && String(layer.get('name')).includes(name)) {
            layer.setVisible(visible)
        }
    });
}

export function setVisibleByLayerName(name, visible = false) {
    window.map.getLayers().forEach(layer => {
        if (layer && String(layer.get('name')) === name) {
            layer.setVisible(visible)
        }
    });
}

export function addLayer(name, checked = null, backgroundLayer = false, showInfo = false, menuElement = undefined) {


    const layer = getLayerByName(name)

    document.querySelector('.info-menu-content').childNodes.forEach((childNode) => {
        if(childNode.classList && !childNode.classList.contains('d-none')) {
            showInfo = false
        }
    })

    const layerMenuOverViewItem = document.querySelector('layer-menu-overview').querySelector(`input[value="${name}"]`)
    if(layerMenuOverViewItem) {
        layerMenuOverViewItem.checked = checked
    }


    if(layer) {

        let visible = !layer.getVisible()
        const kvLayer = getBookmarkPresentationsByID(name)


        if(checked !== null) {

            visible = checked

            if(checked === false) {
                layer.setVisible(checked)
                updateBookmarkPresentationByID(name, 'Visible', checked)
            } else {
                const hasCategoryButEmpty = getDomainListItemsByBookmarkPresentationID(name)

                if(hasCategoryButEmpty === null) {
                    layer.setVisible(checked)
                    updateBookmarkPresentationByID(name, 'Visible', checked)
                } else {
                    layer.setVisible(!hasCategoryButEmpty)
                    updateBookmarkPresentationByID(name, 'Visible', !hasCategoryButEmpty)
                }
            }


            if(kvLayer) {
                updateLayer(name, 'zIndex', kvLayer.zIndex)
            }

        } else {
            updateBookmarkPresentationByID(name, 'Visible', visible)

            layer.setVisible(visible)
        }

        if(!backgroundLayer) {
            showHideLayerOverViewDomainList(name, visible)
        } else {
            if(checked) {
                updateBackgroundSliderValue(name)
            }
        }

        if(showInfo && !isMobile()) {
            // loadInfoCharacteristics(name)
        }

        blockUnBlockZoomElement(name, menuElement, checked)

        updateInfoLegends()
        reloadGeometryLayers()

        if(checked) {
            loadInfoCharacteristics(name, false)

            if(kvLayer) {
                loadLayerOverViewDomainList(kvLayer, menuElement)
            }
        } else {
            if(window.activeCharacteristicsBookmarkID === name) {
                clearInfoCharacteristics()
            }
        }

        updateBackgroundSlider()
        reloadOlSliderOptions()
    } else {
        const layerLoaded = window.layersLoaded.find(layerLoaded => layerLoaded.BookmarkPresentationID === parseInt(name))
        addLoaderByBookmarkPresentationID(parseInt(name))
        if(layerLoaded) {
            const service = new OlServiceModel(name, layerLoaded);
            const olService = new OlService(service);
            olService.addLayer(window.map)

            reloadCesium()
            reloadGeometryLayers()

            loadInfoCharacteristics(name, false)

            if(backgroundLayer && checked) {
                updateBackgroundSliderValue(name)
            }

        } else {
            window.servicePromise = getService(name).then(result => {

                window.layersLoaded.push(result)

                const service = new OlServiceModel(name, result);
                const olService = new OlService(service);
                const layer = olService.addLayer(window.map)

                if (!backgroundLayer) {

                    let datasetElement = document.querySelector('layer-menu-group-item[data-id="' + result.BookmarkPresentationID + '"]')

                    if(!datasetElement) {
                        return
                    }

                    datasetElement.querySelector('input').checked = true

                    let dataset = datasetElement.dataset
                    result.Sorting = dataset.key
                    result.SortingDepth = dataset.depth
                    if(datasetElement.closest('layer-menu-group')) {
                        result.SortingGroupDepth = datasetElement.closest('layer-menu-group').dataset.key
                    }
                    result.DefaultOpacity = result.Opacity
                    bookmarkPresentations.push(result)

                    loadLayerOverViewDomainList(result, menuElement)

                    blockUnBlockZoomElement(name, menuElement, checked)

                    loadInfoCharacteristics(name, false)
                } else {
                    if(checked) {
                        updateBackgroundSliderValue(name)
                    }
                }

                updateInfoLegends()
                setLayerByViewResolution()
                reloadGeometryLayers()

                if(window.urlParamsObject.presentatie === result.DisplayName) {
                    if(window.urlParamsObject.waarde) {
                        if (window.urlParamsObject.attribuut) {
                            getWfsByColumn(result.DomainID, result.PresentationID, urlParamsObject.waarde, window.urlParamsObject.attribuut)
                        } else {
                            callService(name, window.urlParamsObject.waarde, 'wfs', undefined, undefined, true)
                        }
                    }
                }

                updateBackgroundSlider()
                reloadOlSliderOptions()
            })
        }
    }
}

export function updateLayer(name, key, value) {
    let layer = getLayerByName(name)

    if(layer !== null) {
        layer.set(key, value)

        // Opacity for DSO

        if(layer.getSource().get('url') && layer.getSource().getUrl().includes('service_grid')) {
            layer = getLayerByName('mvt-info')
            if(layer) {
                layer.set(key, value)
            }
        }
    }
}

export function updateLayerSource(name, key, value) {
    const layer = getLayerByName(name)
    if(layer !== null) {
        layer.getSource().set(key, value)
    }
}
export function updateLayerStyle(name, style) {
    const layer = getLayerByName(name, false)
    if(layer !== null) {
        layer.setStyle(style)
    }
}

export function updateLayerSourceParams(name, key, value) {
    const layer = getLayerByName(name)
    if(layer) {
        try {
            layer.getSource().updateParams({
                [key]: value
            })
        } catch (error) {
        }
    }
}

export function getLayerSourceParams(name) {
    const layer = getLayerByName(name)
    if(layer) {
        return layer.getSource().getParams()
    }
    return {}
}

export function getLegendUrl(name) {
    const layer = getLayerByName(name)
    if(layer !== null) {
        return layer.getSource().getLegendUrl()
    }
    return ''
}

export function getBookmarkPresentationsByID(ID) {
    return getBookmarkPresentations().find( bookmarkPresentation => bookmarkPresentation.BookmarkPresentationID === parseInt(ID))
}

export function getProjectionByBookmarkPresentationID(id) {
    const bookmarkPresentation = getBookmarkPresentationsByID(id)
    if(bookmarkPresentation) {
        return bookmarkPresentation.Service.Projection
    }
    return null
}

export function getBookmarkPresentationsFilterFormsByBookmarkPresentation(bookmarkPresentation = undefined) {
    return bookmarkPresentation.Forms.filter(form => form.FormTypeTypeID === 4)
}

export function getBookmarkPresentations(sorted = true) {

    if(sorted) {
        return bookmarkPresentations.sort((a,b)=> (a.SortingDepth - b.SortingDepth || a.Sorting.localeCompare(b.Sorting)  ));
    }

    return bookmarkPresentations
}

export function updateBookmarkPresentationByID(ID, key, value) {
    let bookmarkPresentation = getBookmarkPresentationsByID(ID)
    if(bookmarkPresentation !== undefined) {
        bookmarkPresentation[key] = value
    }
}

export function getLayerNamePrefix() {
    return layerNamePrefix
}

export function activateLayer(bookmarkPresentationID) {
    const input = document.querySelector('input[value="' + bookmarkPresentationID + '"]');

    let merged = undefined
    if(input.closest('layer-menu-group-item') && input.closest('layer-menu-group-item').dataset.merged === 'false') {
        merged = false
    }

    const inputGroup = input.closest('layer-menu-group')
    if(merged === undefined && inputGroup && inputGroup.dataset.depth > 0) {
        merged = inputGroup.querySelector('layer-menu-group-merged')
    }

    if(merged) {
        const inputMerged = merged.querySelector('input')
        if(inputMerged && !inputMerged.checked) {
            merged.querySelector('input').click()
        }
    } else {
        if(input && !input.checked) {
            input.click()
        }
    }
}

export function getActiveLayers() {
    let layers = []
    window.layersActive.map((layerActive) => {
        const bookmarkPresentation = getBookmarkPresentationsByID(layerActive)
        if(bookmarkPresentation) {
            layers.push(bookmarkPresentation)
        }

        if(typeof layerActive === 'string') {
            layers.push(layerActive)
        }
    })

    console.log(layers)

    layers.sort((a, b) => parseFloat(b.zIndex) - parseFloat(a.zIndex));

    return layers
}

export function getSnapLayers() {
    let layers = []
    getActiveLayers().map((layerActive) => {
        if(layerActive.Snap) {
            layers.push(layerActive)
        }
    })
    return layers
}

export function removeFeatureByKey(layerSource, key) {
    const feature = layerSource.getFeatures()[key]
    layerSource.removeFeature(feature)
}

export function getFeatureByKey(layerSource, key) {
    return layerSource.getFeatures()[key]
}

export function removeAllActiveLayers() {

    window.layersActive.map((layerActive) => {
        removeLayer(layerActive)
        removeLayerActiveElement(layerActive)
    })

    getAllBySelector('layer-menu-active-item').forEach(element => {
        element.remove()
    })

    getBySelector('#layer-active').innerHTML = ''
    window.layersActive = []
}

export function addLoaderByBookmarkPresentationID(bookmarkPresentationID) {

    setLoaderInnerHtml(bookmarkPresentationID, `
            <div class="sk-wave sk-secondary">
                <div class="sk-wave-rect"></div>
                <div class="sk-wave-rect"></div>
                <div class="sk-wave-rect"></div>
                <div class="sk-wave-rect"></div>
                <div class="sk-wave-rect"></div>
            </div>
    `)
}

export function removeLoaderByBookmarkPresentationID(bookmarkPresentationID) {
    setLoaderInnerHtml(bookmarkPresentationID)
}

function setLoaderInnerHtml(bookmarkPresentationID, innerHTML = '') {
    getAllBySelector('layer-menu-group-item[data-bookmark-presentation-id="' + bookmarkPresentationID + '"], layer-menu-group-item[data-id="' + bookmarkPresentationID + '"]').forEach(element => {
        const label = element.querySelector('.label-sk-wave')
        if(label) {
            label.innerHTML = innerHTML
        }
    })
}

export function getLayerAttributes(service) {
    let attributions = []
    if(service.CopyRights && service.CopyRights.Name) {
        attributions.push(service.CopyRights.Name + ' <span class="far fa-copyright"></span> <a href="' + service.CopyRights.Url + '" target="_blank">' + service.CopyRights.Url + '</a>')
    }
    return attributions
}
